// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2Sp0C","inputWrap":"CustomTip_inputWrap__HdQk7"};